import React from 'react';
import Translate from "../../../../../../../../../../components/Translate";
import {updateAiSupportedLanguages} from "../../../../../../../../../../services/company/api";
import config from "../../../../../../../../../../config";
import AiBlock from "../AiBlock";
import "./styles.css"

const AiSupportedLanguages = ({
                                  addNotification,
                                  aiType,
                                  aiSupportedLanguages,
                                  setAiSupportedLanguages,
                                  client
                              }) => {
    if (aiType !== config.AITypes.GPT_AI && aiType !== config.AITypes.GEMINI_AI
        && aiType !== config.AITypes.TEAM_AI && aiType !== config.AITypes.TEAM_AI_TEST) return null;

    const handleToggleLanguage = (langCode) => {
        if (langCode === "all") {
            updateAiSupportedLanguages(client.id, "all")
                .then(() => {
                    setAiSupportedLanguages("all");
                })
                .catch(() => {
                    addNotification("somethingWentWrong", config.notificationLevels.error);
                });
            return;
        }

        let current = aiSupportedLanguages && aiSupportedLanguages !== "all"
            ? aiSupportedLanguages.split(',').map(l => l.trim().toLowerCase())
            : [];

        let updatedList;
        if (current.includes(langCode)) {
            updatedList = current.filter(l => l !== langCode);
        } else {
            updatedList = [...current, langCode];
        }

        if (updatedList.length >= 3) {
            updateAiSupportedLanguages(client.id, "all")
                .then(() => {
                    setAiSupportedLanguages("all");
                    addNotification("autoSwitchedToAll", config.notificationLevels.info);
                })
                .catch(() => {
                    addNotification("somethingWentWrong", config.notificationLevels.error);
                });
            return;
        }

        const updated = updatedList.length ? updatedList.join(',') : 'all';
        updateAiSupportedLanguages(client.id, updated)
            .then(() => {
                setAiSupportedLanguages(updated);
                if (updated === 'all') {
                    addNotification("autoSwitchedToAll", config.notificationLevels.info);
                }
            })
            .catch(() => {
                addNotification("somethingWentWrong", config.notificationLevels.error);
            });
    };

    const isSelected = (langCode) => {
        if (aiSupportedLanguages === "all") return langCode === "all";
        const list = aiSupportedLanguages ? aiSupportedLanguages.split(',').map(l => l.trim().toLowerCase()) : [];
        return list.includes(langCode);
    };

    return (
        <AiBlock titleKey="aiLanguages" hintKey="aiSupportedLanguagesDescription">
            <div className="ai-langs">
                {config.aiSupportedLanguages.map(lang => (
                    <div
                        key={lang.code}
                        className={'ai-lang' + (isSelected(lang.code) ? ' ai-lang--selected' : '')}
                        onClick={() => handleToggleLanguage(lang.code)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handleToggleLanguage(lang.code);
                            }
                        }}
                        role="button"
                        aria-pressed={isSelected(lang.code)}
                        tabIndex={0}
                    >
                        <span className="ai-lang__flag">{lang.flag}</span>
                        <span>{lang.code === 'all' ? <Translate text="all"/> : lang.name}</span>
                        {lang.code !== 'all' && <span className="ai-lang__code">{lang.code}</span>}
                    </div>
                ))}
            </div>
        </AiBlock>
    );
};

export default AiSupportedLanguages;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/components/AI/AiSupportedLanguages/index.jsx